var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "menu-bar"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, _vm._l(_vm.steps, function (step) {
    return _c('li', {
      key: step.hash,
      class: {
        active: _vm.stepIsActive(step),
        disabled: step.is_disabled,
        'has-checkbox': step.has_checkbox,
        'has-checkbox--checked': step.is_checked
      },
      on: {
        "click": function click($event) {
          return _vm.goToStep(step);
        }
      }
    }, [_c('a', [_vm._v(_vm._s(step.title))])]);
  }), 0)]);
}
var staticRenderFns = []

export { render, staticRenderFns }